export default {
  API_URL: process.env.VUE_APP_API_URL,
  GIT_HASH: process.env.VUE_APP_GIT_HASH,
  PACKAGE_VERSION: process.env.VUE_APP_PACKAGE_VERSION,
  ENABLE_TEST_FIRMWARE: process.env.VUE_APP_ENABLE_TEST_FIRMWARE,
};
